// generated by the plop

import { MasterModel } from 'shared';

export class UpdateGpsLocationMaster {
  static type = '[gpsLocation] UpdateGpsLocationMaster';

  constructor(public master: MasterModel) {
  }
}


export class RequestLocations {
  static type = '[gpsLocation] RequestLocations';

  constructor() {
  }
}
